<template>
    <b-modal id="admission_delete" ref="admission_delete"
             @hidden="resetForm"
             :title="'Delete Admission ' + admission.data.attributes.code + '?'">
        <div class="mb-3">
            You can't revert back your action if you delete this data. For further query, contact Database Manager!
        </div>

        <b-form>
            <b-row v-if="validationError">
                <b-colxx md="12" class="mb-3">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-3">
                    <b-alert show variant="info">
                        Facility: {{ admission.data.attributes.facility }} <br>
                        Unit: {{ admission.data.attributes.unit }} <br>
                        Admission Date: {{ admission.data.attributes.move_in }} <br>
                        Client's Name: {{ admission.data.attributes.client }}
                    </b-alert>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Vacant From" class="has-float-label">
                        <template v-slot:label>
                            <span>Vacant From <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.vacant_from"
                            @input="'vacant_from' in errors ? delete errors.vacant_from : ''"
                            :input-props="{ class:'form-control' + ('vacant_from' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'vacant_from' in errors"
                                                 v-text="'vacant_from' in errors ? errors.vacant_from[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Notes" class="has-float-label">
                        <template v-slot:label>
                            <span>Notes <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea v-model="form.notes" rows="6" :class="{'border-danger': 'notes' in errors}"
                                         @input="'notes' in errors ? delete errors.notes : ''" placeholder="Notes"/>

                        <b-form-invalid-feedback :state="!'notes' in errors"
                                                 v-text="'notes' in errors ? errors.notes[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('admission_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteAdmission">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
    name: "AdmissionDeleteModal",

    components: {
        StateButton,
    },

    data() {
        return {
            datepicker: {
                vacant_from: null,
            },
            form: {
                vacant_from: null,
                notes: '',
            },
            validationError: null,
        }
    },

    props: [
        'admission',
    ],

    computed: {
        ...mapGetters({
            errors: 'getAdmissionErrors',
        }),
    },

    watch: {
        'datepicker.vacant_from'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.vacant_from = null;
            this.form.vacant_from = moment(date).format('YYYY-MM-DD');
        },
    },

    methods: {
        deleteAdmission() {
            let payload = {
                admission_id: this.admission.admission_id,
                form: {...this.form},
            }

            return new Promise((success, fail) => {
                this.$store.dispatch('deleteAdmission', payload)
                    .then(() => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-admission');

                            this.$notify('error filled', 'Success!', 'Deleted the admission!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('admission_delete');
                        }, 2000);
                    })
                    .catch(errors => {
                        this.validationError = errors.response.data.error;

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        resetForm() {
            this.form = {
                vacant_from: null,
                notes: '',
            };

            this.validationError = null;

            this.$emit('closed');
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },
    },
}
</script>

<style scoped>

</style>
